module.exports = __webpack_public_path__ + "static/media/chatapp.6b5433ec.JPG";